import create from "zustand";
import { getAllDevices } from "../../api/devices/allDevices";
import { Device } from "../../types/Device";
import { useAuthStore } from "../auth/auth";
import type { AxiosError } from "axios";


interface DevicesStore {
    devices: Device[];
    fetchDevices: () => Promise<void>;
}

export const useDevicesStore = create<DevicesStore>((set) => ({
    devices: [],
    fetchDevices: async () => {

        const { SmartDVRToken, user } = useAuthStore.getState();
        console.info('[Store:devices] fetchDevices start', { login: user?.login });

        if (!user || !SmartDVRToken) {
            console.error('[Store:devices] запрос не отправлен: отсутствуют user или SmartDVRToken');
            set({ devices: [] });
            return;
        }

        try {
            const response = await getAllDevices(SmartDVRToken, user.login);
            const devicesFromResponse = Array.isArray(response) ? response : (response as any)?.data;

            if (!devicesFromResponse) {
                console.error('[Store:devices] данные не получены от сервера');
                set({ devices: [] });
                return;
            }

            if (!Array.isArray(devicesFromResponse)) {
                console.error('[Store:devices] некорректный формат данных', devicesFromResponse);
                set({ devices: [] });
                return;
            }

            set({ devices: devicesFromResponse as Device[] });
            console.info('[Store:devices] получено устройств', devicesFromResponse.length);
        } catch (error) {
            const err = error as AxiosError<any>;
            const status = err.response?.status;
            const statusText = err.response?.statusText;
            const axiosCode = err.code;
            const data: any = err.response?.data;
            const serverCode = typeof data === 'object' ? (data?.code ?? data?.errorCode ?? data?.status ?? data?.statusCode ?? data?.error?.code) : undefined;
            console.error('[Store:devices] ошибка при получении устройств', {
                status,
                statusText,
                axiosCode,
                serverCode,
                message: err.message,
                data,
            });
            set({ devices: [] });
        }
    }
}));
